import { Tooltip } from '@material-ui/core';
import DataTable from 'react-data-table-component';

import { formatPrice, formatDate, cnpjFormat } from 'src/services/utils';
import { SendReminderButton } from './SendReminderButton';

import './style.css';

function ClientsTable({
  textLinkFornecedor,
  updatingReminderDate,
  optionCard,
  filterClientes,
  clientesAtivos,
}) {
  const renderReminder = item => {
    if (!item?.phone) return <span>Telefone indisponível</span>;

    return (
      <SendReminderButton
        message={textLinkFornecedor}
        phone={item.phone}
        onClick={() => updatingReminderDate(item.retailer_cnpj)}
      />
    );
  };

  const customStyles = {
    header: {
      style: {
        minHeight: '56px',
        fontWeight: 'bolder',
        color: '#000',
      },
    },
    headRow: {
      style: {},
    },
    headCells: {
      style: {
        fontSize: '14px',
      },
    },
    cells: {
      style: {},
    },
    rows: {
      style: {
        fontSize: '12px', // override the row height
      },
      highlightOnHoverStyle: {
        fontWeight: 'bold',
        backgroundColor: 'none',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: 'rgba(0,0,0,.10)',
        outlineStyle: 'solid',
        outlineWidth: '1px',
        outlineColor: 'rgba(0,0,0,.04)',
      },
    },
  };

  const pageOptions = {
    rowsPerPageText: 'Linhas Por Página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
  };

  const columnsAtive = [
    {
      name: (
        <Tooltip title="Nome do cliente">
          <td>Nome do cliente</td>
        </Tooltip>
      ),
      selector: e => e.name,
      cell: e => (
        <Tooltip title={e.name}>
          <div>{e.name}</div>
        </Tooltip>
      ),
      sortable: true,
      grow: 1.5,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="CNPJ">
          <td>CNPJ</td>
        </Tooltip>
      ),
      selector: e => {
        if (!e.retailer_cnpj) {
          return '-';
        }
        return cnpjFormat(e.retailer_cnpj);
      },
      sortable: true,
      grow: 1.2,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Comissão">
          <td>Comissão</td>
        </Tooltip>
      ),
      selector: e => e.commission,
      cell: e => {
        const comissao =
          e.commission == null || e.commission === 0 ? (
            <Tooltip title="0% de comissão">
              <div className="text-comissao">{`${0}%`}</div>
            </Tooltip>
          ) : (
            <Tooltip title="Comissão da última compra">
              <div>{`${e.commission}%`}</div>
            </Tooltip>
          );
        return comissao;
      },
      center: true,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Última compra">
          <td>Última compra</td>
        </Tooltip>
      ),
      selector: e => e.last_bought_date,
      cell: e => formatDate(e.last_bought_date),
      center: true,
      sortable: true,
    },
    {
      name: (
        <Tooltip title="Pedidos">
          <td>Pedidos</td>
        </Tooltip>
      ),
      selector: e => e.orders_amount,
      sortable: true,
      center: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Total comprado">
          <td>Total comprado</td>
        </Tooltip>
      ),
      selector: e => e.orders_value,
      cell: e => {
        const price = e.orders_value ? formatPrice(e.orders_value) : 'N/A';
        return price || 'N/A';
      },
      center: true,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Localização">
          <td>Localização</td>
        </Tooltip>
      ),
      selector: e => e.location,
      sortable: true,
      wrap: true,
      minWidth: '100px',
    },
  ];

  const columnsInative = [
    {
      name: (
        <Tooltip title="Nome do cliente">
          <td>Nome do cliente</td>
        </Tooltip>
      ),
      selector: e => e.name,
      cell: e => {
        const nameDoCliente = (
          <Tooltip title={e.name}>
            <div>{e.name}</div>
          </Tooltip>
        );
        return nameDoCliente;
      },
      sortable: true,
      grow: 1.5,
      minWidth: '150px',
    },
    {
      name: (
        <Tooltip title="CNPJ">
          <td>CNPJ</td>
        </Tooltip>
      ),
      selector: e => e.retailer_cnpj,
      cell: e => {
        if (!e.retailer_cnpj) {
          return '-';
        }
        return cnpjFormat(e.retailer_cnpj);
      },
      sortable: true,
      grow: 1.2,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Localização">
          <td>Localização</td>
        </Tooltip>
      ),
      selector: e => {
        if (!e.location) {
          return '-';
        }
        return e.location;
      },
      sortable: true,
      center: true,
      wrap: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Data de convite">
          <td>Data de convite</td>
        </Tooltip>
      ),
      selector: e => e.referral_date,
      cell: e => {
        if (!e.referral_date || e.referral_date === '-') {
          return '-';
        }
        return formatDate(e.referral_date);
      },
      center: true,
      sortable: true,
      wrap: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Possui cadastro">
          <td>Cadastrado na Inventa</td>
        </Tooltip>
      ),
      selector: e => (e.registered ? 'Sim' : 'Não'),
      sortable: true,
      center: true,
      minWidth: '100px',
    },
    {
      name: (
        <Tooltip title="Data do último lembrete">
          <td>Data do último lembrete</td>
        </Tooltip>
      ),
      selector: e => e.reminder_date,
      cell: e => {
        if (!e.reminder_date) {
          return '-';
        }
        return formatDate(e.reminder_date);
      },
      sortable: true,
      center: true,
      grow: 1.5,
      minWidth: '100px',
    },
    {
      selector: renderReminder,
      center: true,
      wrap: true,
      grow: 1.5,
      minWidth: '150px',
    },
  ];

  return (
    <DataTable
      columns={optionCard === 'ativos' ? columnsAtive : columnsInative}
      data={filterClientes || []}
      customStyles={customStyles}
      pagination
      paginationComponentOptions={pageOptions}
      highlightOnHover="true"
      noDataComponent={
        clientesAtivos ? (
          'Sem resultados...'
        ) : (
          <div className="spinner-border m-5" role="status" />
        )
      }
      fixedHeader
      persistTableHead
      responsive="true"
    />
  );
}

export default ClientsTable;
